<template>
  <div class="body">
    <div>
      <el-select size="mini" placeholder="统计类型" v-model="where.statistical_type" style="width: 180px;">
<!--        <el-option value="" label="全部"></el-option>-->
        <el-option :value="1" label="月度"></el-option>
        <el-option :value="2" label="累计"></el-option>
      </el-select>
      <el-button size="mini" type="primary" @click="reData">刷新</el-button>
    </div>
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit1']">
          <div class="visit-title">项目诉讼</div>
          <div class="visit-chart2" ref="visit1"></div>
        </div>
      </div>
    </div>
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit2']">
          <div class="visit-title">第三方诉讼</div>
          <div class="visit-chart2" ref="visit2"></div>
        </div>
      </div>
    </div>
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit3']">
          <div class="visit-title">诉讼合计</div>
          <div class="visit-chart2" ref="visit3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import * as echarts from "echarts";
import moment from "moment";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "YearLitigationMonth",
  inject:['where','reginWhere'],
  data(){
    return{
      where:{
        statistical_type: 1,
      },
      list:[],
      chart_list:{},
      chart_loading:{
        visit1:true,
        visit2:true,
        visit3:true,
        visit4:true,
        visit5:true,
        visit6:true,
        visit7:true
      },
    }
  },
  mounted() {
    const that=this;
    that.chart_list={}
    window.onresize=function () {
      let chart_list_ids=Object.keys(that.chart_list)
      chart_list_ids.map(ret=>{
        that.chart_list[ret].resize();
      });
    }
    this.reData()
  },
  methods:{
    reData(){
      const that = this;
      that.chart_loading.visit1=true;
      that.getData(2,list=>{
        // console.log(getDataPr(list))
        that.getChart('visit1',visitOption1(getDataPr(list)))
        that.chart_loading.visit1=false;
      })

      that.chart_loading.visit2=true;
      that.getData(4,list=>{
        // console.log(getDataPr(list))
        that.getChart('visit2',visitOption1(getDataPr(list)))
        that.chart_loading.visit2=false;
      })

      that.chart_loading.visit3=true;
      that.getData(9,list=>{
        // console.log(getDataPr(list))
        that.getChart('visit3',visitOption1(getDataPr(list)))
        that.chart_loading.visit3=false;
      })

      // that.getData(2,list=>{
      //   console.log(getDataPr(list))
      //   that.getChart('visit1',visitOption1(getDataPr(list)))
      //   that.chart_loading.visit1=false;
      // })
    },

    getData(urge_type,callback) {
      const that = this;
      ButlerHttp.post("LitigationStatistics/getStatistics",{
          project_ids: typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
          project_id: that.reginWhere.project_name,
          month: moment().format("YYYY-MM"),
          statistical_type: that.where.statistical_type,
          urge_type:urge_type
        }, ret => {
          if (ret.code) {
            callback(ret.data||[])
          }
        }
      )
    },

    getChart(id,option) {
      const that=this;
      let _chart={}
      if(that.chart_list[id]){
        _chart=that.chart_list[id];
        // _chart = echarts.getInstanceByDom(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }else {
        const _chart = echarts.init(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }
      return _chart;
    }
  },
  unmounted() {
    this.chart_list={}
  },
  watch:{
    "reginWhere.project_region":function (n) {
      const that=this;
      CommonHelp.debounce(function () {
        that.reData();
      },500,that);
    },
    "reginWhere.project_name":function (n) {
      const that=this;
      CommonHelp.debounce(function () {
        that.reData();
      },500,that);
    },
    "reginWhere.project_ids":function (n) {
      const that=this;
      CommonHelp.debounce(function () {
        that.reData();
      },500,that);
    },
    "reginWhere.area_id":function (n) {
      const that=this;
      CommonHelp.debounce(function () {
        that.reData();
      },500,that);
    },
    "where.statistical_type":function (n) {
      const that=this;
      CommonHelp.debounce(function () {
        that.reData();
      },500,that);
    },
  }
}
function rand(num=100) {
  return Math.floor(Math.random()*num)
}
function randMax(max=100) {
  return Math.floor(Math.random()*max)
}
function floatRand(num=100) {
  return Math.floor(Math.random()*num)/ num
}
function round(val,n) {
  return Math.round(val*Math.pow(10,n))/Math.pow(10,n)
}
function getDataPr(list2){
  let group_name = [
    {name:"年度计划",field:"year_plan",type:"bar",yIndex:0},
    {name:"月度计划",field:"month_plan",type:"bar",yIndex:0},
    {name:"提交",field:"tj",type:"bar",group:"sj",yIndex:0},
    {name:"诉调",field:"st",type:"bar",group:"sj",yIndex:0},
    {name:"立案",field:"la",type:"bar",group:"sj",yIndex:0},
    {name:"回款",field:"hk",type:"bar",group:"sj",yIndex:0},
    {name:"提交率",field:"tj_rate",type:"line",yIndex:1},
    {name:"立案率",field:"la_rate",type:"line",yIndex:1}
  ];
  //{
//   "id": 7057,
//     "project_id": 461292,
//     "year_month": "2026-01",
//     "yearmonth": null,
//     "urge_type": 2,
//     "statistical_type": 1,
//     "year_plan_num": 0,
//     "year_plan_amount": "0.00",
//     "month_plan_num": 0,
//     "month_plan_amount": "0.00",
//     "tj_num": null,
//     "tj_amount": "0.00",
//     "st_num": null,
//     "st_amount": "0.00",
//     "la_num": null,
//     "la_amount": "0.00",
//     "hk_num": null,
//     "hk_amount": "0.00",
//     "tj_rate": null,
//     "la_rate": null,
//     "create_time": "2026-06-06 21:58:09",
//     "update_time": "2026-06-06 22:44:02"
// }
  let list = [];
  // for (let i=0;i<12;i++){
  //   let t={year_month:(i+1)+"月",year_plan:rand(),month_plan:rand()}
  //   t.tj=randMax(t.year_plan)
  //   t.st=randMax(t.year_plan-t.tj)
  //   t.la=randMax(t.year_plan-t.tj-t.st)
  //   t.hk=randMax(t.year_plan-t.tj-t.st-t.la)
  //   t.tj_rate=round(t.tj/t.year_plan,2)
  //   t.la_rate=round((t.la+t.st+t.la)/t.year_plan,2)
  //   list.push(t)
  // }

  list2.forEach(ret=>{
    let t={year_month:ret.year_month,year_plan:ret.year_plan_num||0,month_plan:ret.month_plan_num||0}
    t.tj=ret.tj_num||0
    t.st=ret.st_num||0
    t.la=ret.la_num||0
    t.hk=ret.hk_num||0
    t.tj_rate=ret.tj_rate||0
    t.la_rate=ret.la_rate||0
    list.push(t)
  })

  return {
    groupName:group_name,
    list
  }
}
function visitOption1({groupName = [], list}) {
  let series=[];
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe',
    '#a964b4',
    '#c5c5c5',
    '#ffd84b',
  ];
  let c_month = moment().format("M")
  groupName.map(ret=>{
    let serie={
      name: ret.name,
      type: ret.type||'bar',
      stack: ret.group,
      data: list.map(ret2=>ret2[ret.field]),
      // color:ret.color||"#0173e7",
      color:colors[groupName.indexOf(ret)],
      yAxisIndex: ret.yIndex||0,
      label: {
        show: true,
        position: 'inside',
        formatter: function (params) {
          if(params.seriesType==="line"){
            return params.value>0?`${params.value}%`: "";
          }
          return params.value>0?`${params.value}`: "";
        }
      },
    }
    if(ret.type==="line"){
      serie.yAxisIndex=1;
      // serie.showSymbol=true
      // serie.smooth= true
    }
    if(ret.type==="bar"){
      serie.barGap= 0
    }
    series.push(serie)
  });
  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      },
      formatter: function (params) {
        let title = params[0].axisValueLabel;
        let data = params.map(ret => {
          if(ret.seriesType==="line"){
            return `<div style="display: flex; justify-content: space-between; padding: 4px 8px;width: 150px;">
            <span>${ret.marker}${ret.seriesName}</span>
            <span>${ret.data || 0}%</span>
          </div>`;
          }else {
            return `<div style="display: flex; justify-content: space-between; padding: 4px 8px;width: 150px;">
            <span>${ret.marker}${ret.seriesName}</span>
            <span>${ret.data || 0}户</span>
          </div>`;
          }

        }).join("");
        return `<div style="font-weight: bold; padding: 4px 8px">${title}</div>${data}`;
      }

    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    // dataZoom: [
    //   {
    //     type: 'slider',
    //     start: c_month>6?0:((12-c_month)/12*100),
    //     end: 100*(c_month/12)
    //   }
    // ],
    legend: {
      data: groupName.map(ret=>ret.name)
    },
    xAxis: [
      {
        type: 'category',
        data: list.map(ret=>ret.year_month),
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '户',
        axisLabel: {
          formatter: '{value} 户'
        },
      },
      {
        type: 'value',
        name: '率',
        // min: 0,
        // max: 1,
        // interval: 5,
        axisLine: {
          show: false
        },
        axisLabel: {
          formatter: '{value} %'
        },
        splitLine:{
          show: false
        },
        minorTick:{
          splitNumber:10
        },
        splitNumber: 10
      }
    ],
    series: series
  };
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body{
  display: flex;
  flex-direction: column;
  background-color: aliceblue;
  overflow-y: scroll;
  height: calc(100vh - 260px);

  .body-item{
    .body-item-header{
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }
    .body-item-main{
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1{
  width: calc( 50% - 30px );
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1{
    width: calc( 100% - 30px );
    height: calc(448px - 80px);
  }
  .visit-chart3{
    width: 400px;
    height: 400px;
  }
  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}


.visit2{
  width: calc( 100% - 10px );
  //height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-chart2{
    width: calc( 100% - 10px );
    height: calc(448px - 30px);
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/lawsuit_overview/YearLitigationMonth.vue